module.exports = __webpack_public_path__ + "img/top-back.bf33d1a2.png";